<template>
    <div class="marquee-wrap" ref="marquee-wrap">
        <div class="scroll" ref="scroll">
            <p class="marquee">{{ val }}</p>
        </div>
        <p class="getWidth" ref="getWidth">{{ val }}</p>
    </div>
</template>

<script>
export default {
    props:{
        val:{
            type:String,
            default:"",
        }
    },
    name: "marquee",
    data() {
        return {
            timer: null,
        };
    },
    created() {
        let timer = setTimeout(() => {
            this.move();
            clearTimeout(timer);
        }, 1000);
    },
    methods: {
        move() {
            if(this.$refs["marquee-wrap"]==null){
                return;
            }
            let maxWidth = this.$refs["marquee-wrap"].clientWidth;
            let width = this.$refs["getWidth"].scrollWidth;
            let movedis = width - maxWidth;
            if (width <= maxWidth){
                return;
            }
            let scroll = this.$refs["scroll"];
            let distance = 0;
            let stop = 0;
            let left = true;
            let stoptime = 0;
            this.timer = setInterval(() => {
                if(stop){
                    stoptime++;
                    if(stoptime>50){
                        stop = false;
                        left = !left;
                    }
                }else{
                    if(left){
                        distance -= 1;
                        if (-distance >= movedis) {
                            stop = true;
                            stoptime = 0;
                        }
                    }else{
                        distance++;
                        if (distance >= 0) {
                            stop = true;
                            stoptime = 0;
                        }
                    }
                    scroll.style.transform = "translateX(" + distance + "px)";
                }
            }, 50);
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
};
</script>

<style scoped>
.marquee-wrap {
    width: 100%;
    overflow: hidden;
    line-height: 18px;
    position: relative;
}
.marquee {
    margin-right: 0.2rem;
}
p {
    word-break: keep-all;
    white-space: nowrap;
    font-size: 14px;
    color: #fff;
}
.scroll {
    display: flex;
}
.getWidth {
    word-break: keep-all;
    white-space: nowrap;
    font-size: 18px;
    position: absolute;
    opacity: 0;
    top: 0;
}
</style>